import { ETextParamType_OnNetCreatedPlayerID, ETextParamType_OnNetPosConnected, ETextParamType_OnNetPosDisconnected, ETextParamType_OnNetVoiceConnected, ETextParamType_OnNetVoiceDisconnected, ETextParamType_OnNetLiveVideoStarted, ETextParamType_OnNetLiveVideoEnded, ETextParamType_OnNetLiveVideoPlay, ETextParamType_OnNetLiveVideoStop, ETextParamType_OnNetLiveConfirmPlayVideo, ETextParamType_OnNetReceivePosJoin, ETextParamType_OnNetReceivePosLeave, ETextParamType_OnNetReceiveVoiceJoin, ETextParamType_OnNetReceiveVoiceLeave, ETextParamType_OnNetLiveConnected, ETextParamType_OnNetLiveDisconnected, ETextParamType_OnNetLiveRemoteJoin, ETextParamType_OnNetLiveRemoteLeave, ETextParamType_OnNetEstablishmentFail, ETextParamType_OnNetConnectionError, ETextParamType_OnNetOperationError, worldViewerWindow } from '../const';
export class CHeliNetworkCallback {
    OnChangedMicPermissionState(MicPermissionState) {
        worldViewerWindow.hel_postMessage(worldViewerWindow.ETextParamType_OnChangedMicPermissionState, MicPermissionState.toString());
    }
    OnNetCreatedPlayerID(ID) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetCreatedPlayerID, ID);
    }
    OnNetPosConnected() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetPosConnected, '');
    }
    OnNetVoiceConnected(VoiceID) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetVoiceConnected, VoiceID);
    }
    OnNetLiveConnected() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveConnected, '');
    }
    OnNetPosDisconnected() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetPosDisconnected, '');
    }
    OnNetVoiceDisconnected() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetVoiceDisconnected, '');
    }
    OnNetLiveDisconnected() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveDisconnected, '');
    }
    OnNetReceivePosJoin(ID, Data) {
        if (worldViewerWindow.cef_OnNetReceivePosJoin !== undefined) {
            worldViewerWindow.cef_OnNetReceivePosJoin(ID, Data);
        } else {
            const params = ID + ',' + Data;
            worldViewerWindow.hel_setText(ETextParamType_OnNetReceivePosJoin, params);
        }
    }
    OnNetReceivePosLeave(ID, Data) {
        if (worldViewerWindow.cef_OnNetReceivePosLeave !== undefined) {
            worldViewerWindow.cef_OnNetReceivePosLeave(ID, Data);
        } else {
            const params = ID + ',' + Data;
            worldViewerWindow.hel_setText(ETextParamType_OnNetReceivePosLeave, params);
        }
    }
    OnNetReceiveVoiceJoin(ID, Data) {
        if (worldViewerWindow.cef_OnNetReceiveVoiceJoin !== undefined) {
            worldViewerWindow.cef_OnNetReceiveVoiceJoin(ID, Data);
        } else {
            const params = ID + ',' + Data;
            worldViewerWindow.hel_setText(ETextParamType_OnNetReceiveVoiceJoin, params);
        }
    }
    OnNetReceiveVoiceLeave(ID, Data) {
        if (worldViewerWindow.cef_OnNetReceiveVoiceLeave !== undefined) {
            worldViewerWindow.cef_OnNetReceiveVoiceLeave(ID, Data);
        } else {
            const params = ID + ',' + Data;
            worldViewerWindow.hel_setText(ETextParamType_OnNetReceiveVoiceLeave, params);
        }
    }
    OnNetLiveRemoteJoin(playerId) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveRemoteJoin, playerId);
    }
    OnNetLiveRemoteLeave(playerId) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveRemoteLeave, playerId);
    }
    OnNetEstablishmentFail(errorCode) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetEstablishmentFail, errorCode);
    }
    OnNetConnectionError(errorCode) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetConnectionError, errorCode || '');
    }
    OnNetOperationError(errorCode) {
        worldViewerWindow.hel_setText(ETextParamType_OnNetOperationError, errorCode || '');
    }
    OnNetLiveVideoStarted() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveVideoStarted, '');
    }
    OnNetLiveVideoEnded() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveVideoEnded, '');
    }
    OnNetLiveVideoPlay() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveVideoPlay, '');
    }
    OnNetLiveVideoStop() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveVideoStop, '');
    }
    OnNetLiveConfirmPlayVideo() {
        worldViewerWindow.hel_setText(ETextParamType_OnNetLiveConfirmPlayVideo, '');
    }
    // ネットワークで使用するTransform情報のリクエスト
    OnNetRequestCurrentLocalTransform() {
        worldViewerWindow.hel_script_CallCanvasComponentMethod('vcc_icon_only_base', 'VCCViewModel', 'RequestCurrentLocalTransform');
    }
}
